import { RoleAuthService } from './../services/roleAuthService.service';
import { Location } from '@angular/common';
import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, Input, Output, ViewContainerRef, EventEmitter } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import * as _ from 'underscore';


@Component({
    selector: 'editRoleAuthorization',
    templateUrl: 'editRoleAuthorization.component.html',
    styleUrls: ['../../biAdminStyles.css']
})

export class editRoleAuthorizationComponent {
    public showChild: boolean[] = [];

    public accessDenied: boolean = false;
    public loader: boolean = true;
    public saveChangesButton: boolean = false;
    public pageList: any = [];
    public pageSectionMap: any = new Map;
    public mainPage: boolean = true;
    public selectedAll: number[] = [];
    public roleAuthList: any = [];
    public raMap: any = new Map();
    public raModifiedMap: any = new Map();
    public paCntMap: any = new Map();
    public selectedpsList: any = [];
    public changes: boolean = false;


    @Input() roleId: any = [];
    @Input() roleName: string;

    @Output() onEdit = new EventEmitter


    constructor(public mdmService: MDMService,
        public roleAuthService: RoleAuthService,
        public toastr: ToasterComponent,
        public location: Location,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(this.vcr);
    }

    ngOnChanges() {
        this.loadData();
    }

    public loadData() {
        let self = this;
        self.loadPages().then((res) => {
            self.loadRoleAuthorizations()
        }, (err) => {
            console.error(err);
        });
    }

    async loadPages() {
        this.loader = true;
        this.pageList = await this.roleAuthService.getPages();
        this.loader = false;
    }

    async loadRoleAuthorizations() {
        this.loagPageSection();
        this.loader = true;
        this.selectedAll = [];
        this.roleAuthList = [];
        this.raModifiedMap.clear();
        this.raMap.clear();
        this.paCntMap.clear();
        try {
            this.roleAuthList = await this.roleAuthService.getRoleAuth(this.roleId);
        } catch (e) { this.roleAuthList = null; }
        this.setRoleAuth();
        for (let i = 0; i < this.pageList.length; i++) {
            this.setSelectedAll(i)
        }
        this.loader = false;
        this.mainPage = true;

    }

    public loagPageSection() {
        let self = this;
        let secId = [];
        let pageId = [];
        self.pageList.forEach(page => {
            pageId.push(page.id);
            page.sections.forEach(section => {
                secId.push(section.id);
                self.pageSectionMap.set(page.id, secId);
            });
            secId = [];
        });
    }

    public setRoleAuth() {
        let self = this;
        if (!self.roleAuthList) return;
        for (let raData of self.roleAuthList) {
            if (!self.raMap.has(raData.pageSectionId)) {
                self.raMap.set(raData.pageSectionId, raData.state);
                for (let paData of self.pageList) {
                    for (let psData of paData.sections) {
                        if (psData.id == raData.pageSectionId) {
                            if (!self.paCntMap.has(paData.id)) {
                                self.paCntMap.set(paData.id, 1);
                            } else {
                                let value = self.paCntMap.get(paData.id);
                                self.paCntMap.set(paData.id, value + 1);
                            }
                        }
                    }
                }
            }
        }
    }

    public selectAll(pageId, index, state) {
        let self = this;
        self.saveChangesButton = true;
        let raData: any;
        let psList = self.pageSectionMap.get(pageId)
        self.selectedAll[index] = state;
        for (let psId of psList) {
            state != 1 ? self.raMap.set(psId, state) && self.paCntMap.set(pageId, psList.length) :
                self.raMap.set(psId, state) && self.paCntMap.set(pageId, 0);
            raData = { pageId: pageId, pageSectionId: psId, state: state };
            self.raModifiedMap.set(psId, raData);
        }      
        self.selectedpsList[index] = null;
    }

    public onChange(pageId,psId,index,chbox) {
        let self = this;
        // let pageId = +event.target.value;
        // let psId = +event.target.id;
        // let chbox = event.target.checked;
        self.saveChangesButton = true;
        let raData = { pageId: pageId, pageSectionId: psId, state: chbox, deleted: chbox == 1 ? true : false };
        // let value = 0;
        // if (self.paCntMap.has(raData.pageId)) {
        //     value = self.paCntMap.get(raData.pageId);
        // }
        // chbox ? self.paCntMap.set(raData.pageId, value + 1) :
        //     self.paCntMap.set(raData.pageId, value - 1);
        let prevState = self.raMap.has(psId) ? self.raMap.get(psId) : chbox;
        self.raMap.set(psId, chbox);
        let value = self.paCntMap.has(pageId) ? self.paCntMap.get(pageId) : 0;
        if (prevState == 1 && chbox != 1) {
            self.paCntMap.set(pageId, value + 1);
        } else if (prevState != 1 && chbox == 1){
            self.paCntMap.set(pageId, value - 1);
        } else if(prevState == chbox && chbox != 1){
            self.paCntMap.set(pageId, value + 1);
        }
        self.setSelectedAll(index);
        self.raModifiedMap.set(psId, raData);
    }

    public SaveChanges() {
        let self = this;
        self.OnSaveChanges().then((res) => {
            if(res){
                self.rolesBack();
            }
        }, (err) => {
            self.changes = false;
        });

    }

    OnSaveChanges() {    
        let self = this;
        let psIdList_save = [];
        let psIdList_del = [];
        self.pageSectionMap.forEach(page => {
            if (page != undefined) {
                page.forEach(psId => {
                    let data = self.raModifiedMap.has(psId) ? self.raModifiedMap.get(psId) : null;
                    if (data != null) {
                        let authData = { pageSectionId:data.pageSectionId, state:data.state };
                        (data.state != 1) ? psIdList_save.push(authData) :
                            psIdList_del.push(authData);
                    }
                });
            }
        });     
        let IdList_del = [];
        if (self.roleAuthList != null){
            if(psIdList_del && psIdList_del.length){
                psIdList_del.forEach(ele => {
                    let psId;
                    self.roleAuthList.forEach(prevAuth => {
                        if(ele.pageSectionId == prevAuth.pageSectionId && ele.state != prevAuth.state){
                            psId = ele;
                        }
                    });
                    psId ? IdList_del.push(psId) : null;
                });
            }
        }
        if (self.roleAuthList != null){
            if(psIdList_save && psIdList_save.length){
                self.roleAuthList.forEach(prevAuth => {
                    psIdList_save.forEach((ele,i) => {
                        if(ele.pageSectionId == prevAuth.pageSectionId && ele.state == prevAuth.state){
                            psIdList_save.splice(i,1);
                        }
                    });
                });
            }
        }
        let finalList = IdList_del && IdList_del.length ? IdList_del.concat(psIdList_save) : psIdList_save;
        return new Promise((resolve, reject) => {
            if(finalList && finalList.length){
                self.loader = true;
                self.roleAuthService.editOrSave('/save', finalList, self.roleId).then((res) => {
                    if(res && res.success){
                        self.changes = true;
                        self.loader = false;
                        self.toastr.showSuccess('Changes saved successsfully');
                        resolve('success');
                    }else if(res && !res.success){
                        self.loader = false;
                        self.toastr.showError('Failed to save changes');
                        resolve('error');
                    }
                });
            }else{
                resolve('null');
            }
        });
        // console.log(psIdList_save);
        // console.log(psIdList_del);           
        // return;
        // if (psIdList_del.length || psIdList_save.length) {
        //     self.loader = true;
        //     self.roleAuthList == null ? psIdList_del = [] : null;
        //     self.removeAuth(psIdList_del).then((res) => {
        //         self.addAuth(psIdList_save).then((res) => {
        //             self.changes = true;
        //             self.loader = false;
        //             resolve();
        //         });
        //     });
        // } else {
        //     self.loader = false;
        //     resolve();
        // };   

    }

    // removeAuth(psIdList) {
    //     let self = this;
    //     let npsIdList = [];
    //     return new Promise((resolve) => {
    //         if (!psIdList.length) resolve('');
    //         if (self.roleAuthList != null){
    //             psIdList.forEach(ele => {
    //                 let psId;
    //                 self.roleAuthList.forEach(prevAuth => {
    //                     if(ele.id == prevAuth.pageSectionId){
    //                         psId = ele;
    //                     }
    //                 });
    //                 psId ? npsIdList.push(psId) : null;
    //             });
    //         }else npsIdList = psIdList;
    //         if(npsIdList.length){
    //             self.roleAuthService.editOrSave('/remove', npsIdList, self.roleId).then((res) => {
    //                 resolve(res);
    //             });
    //         }else resolve('');
    //     });
    // }

    // addAuth(psIdList) {
    //     let self = this;
    //     return new Promise((resolve) => {
    //         if (!psIdList.length) resolve('');
    //         if (self.roleAuthList != null){
    //             self.roleAuthList.forEach(prevAuth => {
    //                 psIdList.forEach((ele,i) => {
    //                     if(ele.id == prevAuth.pageSectionId && ele.state == prevAuth.state){
    //                         psIdList.splice(i,1);
    //                     }
    //                 });
    //             });
    //         }
    //         if(psIdList.length){
    //             self.roleAuthService.editOrSave('/save', psIdList, self.roleId).then((res) => {
    //                 resolve(res);
    //             });
    //         }else resolve('');
    //     });
    // }

    public toggleChild(i) {
        let self = this;
        self.showChild[i] = !self.showChild[i];
    }

    public setSelectedAll(index) {

        let self = this;
        let enable = [];
        let disable = [];
        let lock = [];
        let flag = false;
        let i = index
        // for (let i = 0; i < self.pageList.length; i++) {
            let psList = self.pageSectionMap.get(self.pageList[i].id);
            if (psList && psList.length == self.paCntMap.get(self.pageList[i].id)) {
                for(let j=0;j<psList.length;j++){
                    if(self.raMap.get(psList[j]) == 0){
                        enable.push(0);
                    }else if(self.raMap.get(psList[j]) == 1){
                        disable.push(1);
                    }else if(self.raMap.get(psList[j]) == 2){
                        lock.push(2);
                    } 
                    this.selectedpsList[i] = null;
                }
                if(psList.length == enable.length){
                    self.selectedAll[index] = 0;
                }else if(psList.length == disable.length){
                    self.selectedAll[index] = 1;
                }else if(psList.length == lock.length){
                    self.selectedAll[index] = 2;
                }else{
                    self.selectedAll[index] = 3;
                }
            } else {
                self.selectedAll[i] = 3;
                this.selectedpsList[i] = self.paCntMap.get(self.pageList[i].id);
            }
            if(!self.paCntMap.has(self.pageList[i].id) || self.paCntMap.get(self.pageList[i].id) == 0){
                self.selectedAll[index] = 1;
            }
                             
        // }
        
    }

    public hasChilds() {
        return this.pageList.sections != null && this.pageList.sections.length > 0;
    }

    public rolesBack() {
        this.onEdit.emit(this.changes);
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/editRoleAuthorization.component.ts